import { useState } from "react";

import { makeGetApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

import WorkOrderDetailsModel from "../../components/forms/workOrders/WorkOrderDetailsModal";

import { format } from "date-fns";

export function ScheduleViewModel(addSnackbar, logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [calendar, setCalendar] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(null);

  const getCalendar = async function (month = currentMonth) {
    const formattedMonth = format(month, "yyyy-MM");
    let callResult = await makeGetApiCall(
      `calendarForEmployee?month=${formattedMonth}`
    );
    if (callResult.success) {
      setCalendar(callResult.data);
      setSelectedDay(callResult.data.find((day) => day.isSelected));
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const openWoDetails = (workOrder) => {
    setEmptyModelOpen({
      childComponent: (
        <WorkOrderDetailsModel
          workOrder={workOrder}
          closeModal={() =>
            setEmptyModelOpen({
              open: false,
              childComponent: null,
            })
          }
          goToDetails={() => (window.location = `/work-orders/${workOrder.id}`)}
        />
      ),
      open: true,
    });
  };

  const handleDaySelect = (selectedDate) => {
    console.log("selectedDate", selectedDate);
    const updatedDays = calendar.map((day) => ({
      ...day,
      isSelected: day.date === selectedDate, // true for clicked day, false for others
    }));

    setCalendar(updatedDays);
  };

  const onChangeMonth = (newMonth) => {
    setCurrentMonth(newMonth);
    getCalendar(newMonth);
  };

  return {
    emptyModal,
    calendar,
    currentMonth,
    onChangeMonth,
    getCalendar,
    openWoDetails,
    setEmptyModelOpen,
    selectedDay,
    setSelectedDay,
    handleDaySelect,
  };
}
